module.exports = __webpack_public_path__ + "static/media/15UN-Habitat16.a56e63c0.jpg";